<template>
  <base-content
    :data="data"
    :index="index"
    view="list"
  >
    <template #card-header>
      <partial-title :title="title" :link="link" />
    </template>

    <template #card-body>
      <partial-description v-if="description"
        :description="description"
        :isLoading="highlightsLoading"
      />

      <ul :class="{ 'mt-2': description }">
        <matches v-if="!isEmpty(matches)" :matches="matches" view="list" />
      </ul>
    </template>

    <template #card-footer>

      <li class="row-content">
        <i class="fa fa-calendar row-content--side"></i>
        <span class="row-content--main" v-line-clamp="1">
          <span v-if="!isEmpty(data.granted_date)">Granted {{ data.granted_date | formatDate('YYYY') }}</span>
          <span v-if="isEmpty(data.granted_date) && !isEmpty(data.priority_date)">Priority {{ data.priority_date | formatDate('YYYY') }}</span>
          <span v-if="isEmpty(data.granted_date) && isEmpty(data.priority_date)">Application {{ data.application_date | formatDate('YYYY') }}</span>
          <span v-html="patentNumber" class="t-secondary pl-2"></span>
        </span>
      </li>

      <partial-organisations v-if="!isEmpty(applicants)"
        :organisations="sortOrder(applicants)"
        :highlights="highlightApplicants"
        :highlightKeys="['applicants.full_name.normalized', 'applicants.initial_name.normalized']"
        :lineClamp="1">
      </partial-organisations>

      <partial-organisations v-if="isEmpty(applicants) && !isEmpty(assignees)"
        :organisations="sortOrder(assignees)"
        :highlights="highlightAssignees"
        :highlightKeys="['assignees.full_name.normalized', 'assignees.initial_name.normalized']"
        :lineClamp="1">
      </partial-organisations>

    </template>

    <template #card-actions>
      <slot name="actions"></slot>
    </template>
  </base-content>
</template>

<script>
import processing from '@/mixins/search/results/patent'

import BaseContent from '@/components/search/results/BaseContent'
import Matches from '@/components/search/results/partials/Matches'
import PartialDescription from '@/components/search/results/partials/Description'
import PartialTitle from '@/components/search/results/partials/Title'
import PartialOrganisations from '@/components/search/results/partials/Organisations'

export default {
  name: 'patentResultList',
  mixins: [processing],
  components: {
    Matches,
    BaseContent,
    PartialTitle,
    PartialDescription,
    PartialOrganisations
  }
}
</script>
